import * as React from 'react';

const PytorchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="28" viewBox="0 0 24 28" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_781_1287)">
            <path
                d="M11.9842 0V4.06932L5.73175 10.3216C2.45946 13.6405 2.45979 18.9793 5.73276 22.3583L5.83294 22.4601C9.17672 25.867 14.6656 25.867 18.0724 22.4601C21.4453 19.1498 21.479 13.7371 18.1736 10.3234L18.0724 10.2206L20.1544 8.13864C24.6969 12.6811 24.6969 19.9681 20.1544 24.5421C15.7066 29.0846 8.38809 29.0846 3.84559 24.5421C-0.651479 20.045 -0.69645 12.8272 3.71068 8.27575L3.84559 8.13864L11.9842 0ZM16.0851 4.60559C16.9214 4.60559 17.5993 5.2835 17.5993 6.11975C17.5993 6.95601 16.9214 7.63392 16.0851 7.63392C15.2489 7.63392 14.5709 6.95601 14.5709 6.11975C14.5709 5.2835 15.2489 4.60559 16.0851 4.60559Z"
                fill="#EE4C2C"
            />
        </g>
        <defs>
            <clipPath id="clip0_781_1287">
                <rect fill="white" height="28" transform="translate(0.438721)" width="23.1226" />
            </clipPath>
        </defs>
    </svg>
);
export default PytorchIcon;
